import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuthedGet } from "@/pages/Admin";

const DURATIONS = [["1", "1 nap"], ["7", "7 nap"], ["30", "30 nap"], ["perm", "Végleges"]];

// target: { nick, ip, device_id, report_id?, conversation_id?, reason? }
export const BanDialog = ({ target, onClose, onDone }) => {
  const req = useAuthedGet();
  const [byIp, setByIp] = useState(true);
  const [byDevice, setByDevice] = useState(true);
  const [duration, setDuration] = useState("7");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!target) return;
    setByIp(false); setByDevice(!!target.device_id); setDuration("7"); setReason(target.reason || "");
  }, [target]);

  const submit = async () => {
    setBusy(true);
    try {
      await req("/admin/bans", {
        method: "post",
        data: {
          ip: byIp ? target.ip || "" : "", device_id: byDevice ? target.device_id || "" : "", nick: target.nick || "",
          reason, duration_days: duration === "perm" ? null : Number(duration),
          report_id: target.report_id || null, conversation_id: target.conversation_id || null,
        },
      });
      toast.success(`${target.nick || "Felhasználó"} kitiltva`);
      onDone?.();
      onClose();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Nem sikerült kitiltani");
    } finally { setBusy(false); }
  };

  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md border-white/10 bg-[#1A152E]" data-testid="ban-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">{target?.nick || "Felhasználó"} kitiltása</DialogTitle>
          <DialogDescription>A kitiltott felhasználó azonnal kikerül a beszélgetésből, és nem tud újra csatlakozni.</DialogDescription>
        </DialogHeader>
        <label className="flex items-center gap-3 text-sm">
          <input type="checkbox" checked={byIp} disabled={!target?.ip} onChange={(e) => setByIp(e.target.checked)} className="h-4 w-4 accent-[#FF3B6C]" data-testid="ban-by-ip-checkbox" />
          IP-cím: <span className="font-mono text-xs text-muted-foreground">{target?.ip || "nincs"}</span>
        </label>
        <label className="flex items-center gap-3 text-sm">
          <input type="checkbox" checked={byDevice} disabled={!target?.device_id} onChange={(e) => setByDevice(e.target.checked)} className="h-4 w-4 accent-[#FF3B6C]" data-testid="ban-by-device-checkbox" />
          Eszköz: <span className="truncate font-mono text-xs text-muted-foreground">{target?.device_id || "nincs"}</span>
        </label>
        {byIp && (
          <p className="rounded-2xl bg-[#FFD600]/10 px-4 py-2 text-xs text-[#FFD600]" data-testid="ban-ip-warning">
            Figyelem: mobilnetes és közös wifis IP-címet sokan használhatnak egyszerre, az IP-tiltás ártatlanokat is kizárhat.
          </p>
        )}
        <div className="flex flex-wrap gap-2">
          {DURATIONS.map(([k, l]) => (
            <button key={k} onClick={() => setDuration(k)} data-testid={`ban-duration-${k}`}
              className={`rounded-full px-4 py-1.5 text-xs font-bold transition-colors ${duration === k ? "bg-[#FF3B6C] text-white" : "bg-white/5 hover:bg-white/10"}`}>{l}</button>
          ))}
        </div>
        <input value={reason} onChange={(e) => setReason(e.target.value)} maxLength={300} placeholder="Indok (a felhasználó is látja)" data-testid="ban-reason-input"
          className="rounded-full border border-white/10 bg-white/5 px-4 py-2.5 text-sm outline-none focus:border-[#FF3B6C]" />
        <button onClick={submit} disabled={busy || (!byIp && !byDevice)} data-testid="ban-submit-button"
          className="rounded-full bg-[#EF4444] px-6 py-3 font-bold text-white transition-transform hover:scale-[1.02] disabled:opacity-40">
          {busy ? "Tiltás…" : "Kitiltás"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
